/* global $, mtbn */

import Vue from 'vue'
import {logPageImpression} from '../analytics/analytics'
import {logGoogleAnalyticsEvent} from '../analytics/google-analytics'
import initInfiniteScrolling from '../ux/infinite-scrolling'
import updateAddressBar from '../ux/address-bar'
import {filterNameToUrlParameter, urlParameterToFilterName} from './filter-attribute-url-map'

export default function () {
    window.services = new Vue(
        {
            el: '#services-app',
            data: {
                filterAttributes: {}
            },
            computed: {
                filterAttributesComputed: function () {
                    let attributes = {}
                    for (let attributeName in this.filterAttributes) {
                        if (!this.filterAttributes.hasOwnProperty(attributeName)) {
                            continue
                        }
                        attributes[attributeName] = {
                            is_visible: this.isFilterAttributeVisible(attributeName)
                        }
                    }
                    return attributes
                }
            },
            created: function () {
                this.initFilterAttributes()
                this.updateFilterAttributesFromUrl()
                this.addOnPopStateHandler()
            },
            methods: {
                initFilterAttributes: function () {
                    let filterAttributes = {}
                    for (let attributeName in mtbn.bikemarkt.services) {
                        if (!mtbn.bikemarkt.services.hasOwnProperty(attributeName)) {
                            continue
                        }
                        filterAttributes[attributeName] = mtbn.bikemarkt.services[attributeName]
                        filterAttributes[attributeName].showLoadingIndicator = false
                    }
                    this.filterAttributes = filterAttributes
                },
                resetFilterAttributesUpTo: function (filterAttribute) {
                    let foundFilterAttribute = false
                    for (let attributeName in this.filterAttributes) {
                        if (!this.filterAttributes.hasOwnProperty(attributeName)) {
                            continue
                        }
                        if (foundFilterAttribute === true || attributeName === filterAttribute.name) {
                            foundFilterAttribute = true
                            this.filterAttributes[attributeName].selected_value = ''
                        }
                    }
                    this.initFilterAttributes()
                    this.loadItems(filterAttribute.name)
                    updateAddressBar(this.getRequestUrl())
                },
                selectFilterAttribute: function (filterAttribute, slug) {
                    filterAttribute.selected_value = slug
                    this.loadItems(filterAttribute.name)
                    updateAddressBar(this.getRequestUrl())
                },
                isFilterAttributeVisible: function (attributeName) {
                    let isFirstAttribute = true
                    for (let tmpAttributeName in this.filterAttributes) {
                        if (!this.filterAttributes.hasOwnProperty(tmpAttributeName)) {
                            continue
                        }
                        if (isFirstAttribute === true && tmpAttributeName === attributeName) {
                            return true
                        }
                        isFirstAttribute = false

                        if (this.filterAttributes[tmpAttributeName].selected_value !== '') {
                            return true
                        }
                    }
                },
                updateFilterAttributesFromUrl: function () {
                    const queryParameters = window.document.location.search.substr(1).split('&')
                    let filterSettings = {}
                    queryParameters.forEach((value) => {
                        const parts = value.split('=')
                        let attributeName = urlParameterToFilterName(parts[0])
                        filterSettings[attributeName] = parts[1]
                    })

                    for (let tmpAttributeName in this.filterAttributes) {
                        if (!this.filterAttributes.hasOwnProperty(tmpAttributeName)) {
                            continue
                        }
                        if (tmpAttributeName in filterSettings) {
                            this.filterAttributes[tmpAttributeName].selected_value = filterSettings[tmpAttributeName]
                        } else {
                            this.filterAttributes[tmpAttributeName].selected_value = '';
                        }
                    }
                },
                getRequestData: function () {
                    const requestData = []

                    for (let tmpAttributeName in this.filterAttributes) {
                        if (!this.filterAttributes.hasOwnProperty(tmpAttributeName)) {
                            continue
                        }

                        if (this.filterAttributes[tmpAttributeName].selected_value !== '') {
                            requestData.push(
                                filterNameToUrlParameter(tmpAttributeName, true) +
                                '=' +
                                this.filterAttributes[tmpAttributeName].selected_value
                            )
                        }
                    }

                    return requestData.join('&')
                },
                getRequestUrl: function () {
                    return window.document.location.pathname + '?' + this.getRequestData()
                },
                loadItems: function (filterAttributeName) {
                    let app = this
                    $.get(
                        {
                            url: this.getRequestUrl(),
                            data: this.getRequestData(),
                            beforeSend: function () {
                                if (filterAttributeName !== '') {
                                    app.showLoadingIndicator(filterAttributeName)
                                }
                            },
                            success: (data) => {
                                $('.js__view-services-items__container').html(data)
                                // initLazyLoad()
                            },
                            complete: function () {
                                if (filterAttributeName !== '') {
                                    app.hideLoadingIndicator(filterAttributeName)
                                }
                                logPageImpression()
                                logGoogleAnalyticsEvent('bikemarkt', 'category', 'apply services filter')
                                initInfiniteScrolling()
                            }
                        }
                    )
                },
                showLoadingIndicator: function (filterAttributeName) {
                    this.filterAttributes[filterAttributeName].showLoadingIndicator = true
                    $('.productsList').css('opacity', '0.5')
                },
                hideLoadingIndicator: function (filterAttributeName) {
                    $('.productsList').css('opacity', '1.0')
                    this.filterAttributes[filterAttributeName].showLoadingIndicator = false
                },
                addOnPopStateHandler: function () {
                    const app = this;
                    $(window).on('popstate', function (event) {
                        app.updateFilterAttributesFromUrl();
                        app.loadItems('')
                    })
                }
            }
        }
    )
}
